import React from "react";
import LegalShell, { Section } from "@/pages/LegalShell";

export default function HowItWorksPage() {
    return (
        <LegalShell
            overline="Comment ça marche"
            title="Un renfort professionnel, en 3 étapes."
            subtitle="Renforteo automatise chaque étape entre l'entreprise qui a besoin de personnel et le professionnel qui cherche une mission. Voici comment se déroule concrètement une collaboration."
            cta={{
                title: "Prêt à publier votre première mission ?",
                text: "Le devis est instantané et sans engagement.",
                to: "/devis",
                label: "Estimer ma mission",
            }}
        >
            <Section title="1. Vous décrivez votre besoin" id="etape-1">
                <p>
                    En quelques minutes, indiquez le métier recherché, la date, les horaires, la ville
                    et le nombre de personnes. Ajoutez les compétences requises (langues, permis,
                    expérience), la tenue attendue et les éventuels frais annexes.
                </p>
                <p>
                    Notre moteur tarifaire calcule immédiatement une estimation détaillée :
                    honoraires HT du professionnel, frais plateforme Renforteo (15 %), TVA (selon
                    statut du professionnel), acompte et total TTC. Cette estimation reste
                    indicative — le montant définitif dépend des heures effectivement réalisées,
                    des majorations éventuelles (nuit, dimanche, jour férié) et des frais
                    additionnels validés en amont.
                </p>
            </Section>

            <Section title="2. Vous recevez des candidatures qualifiées" id="etape-2">
                <p>
                    Dès la validation du devis, votre mission est diffusée en priorité aux
                    professionnels les plus compatibles à proximité, dans la limite du rayon de
                    mobilité qu'ils ont eux-mêmes défini.
                </p>
                <p>
                    Chaque candidature est enrichie d'un <b>score de compatibilité</b> calculé à
                    partir du métier, de la distance, de la note moyenne, de l'expérience et des
                    langues. Vous pouvez comparer jusqu'à trois candidats côte-à-côte et retenir
                    celui qui vous correspond le mieux.
                </p>
            </Section>

            <Section title="3. Vous gérez la mission depuis un seul espace" id="etape-3">
                <p>
                    Une fois le professionnel choisi, une messagerie privée s'ouvre entre vous
                    pour partager les consignes, le plan d'accès, la tenue ou tout changement.
                    À l'issue de la prestation, le professionnel déclare ses heures, vous les
                    validez et la facture est générée automatiquement.
                </p>
                <p>
                    Contrats de prestation, feuilles d'heures, factures du professionnel et
                    factures Renforteo (frais plateforme) sont archivés et téléchargeables à tout
                    moment dans votre espace. <b>Aucune déclaration sociale n'est à votre charge</b> :
                    tous nos professionnels sont des auto-entrepreneurs / indépendants immatriculés
                    (SIRET vérifié) qui facturent en direct et gèrent seuls leurs cotisations.
                </p>
            </Section>

            <Section title="Vous êtes professionnel ?" id="candidat">
                <p>
                    Créez votre profil en 5 minutes : coordonnées, métier principal, expériences,
                    documents justificatifs (SIRET, KBIS, carte d'identité, justificatif de
                    domicile), disponibilités et rayon de mobilité. Après vérification manuelle
                    de votre dossier par notre équipe, vous recevez uniquement les missions
                    proches de chez vous qui correspondent à votre profil.
                </p>
                <p>
                    <b>Pas encore d'auto-entreprise ?</b> La création d'un numéro de SIRET est{" "}
                    <b>100 % gratuite</b> sur le site officiel du gouvernement et prend une
                    dizaine de minutes. Notre équipe peut vous accompagner gratuitement à chaque
                    étape (choix du code APE, régime fiscal, domiciliation) — il suffit de nous
                    écrire à <a href="mailto:contact@renforteo.fr" className="text-[#0B192C] font-semibold underline hover:text-[#F5A623]">contact@renforteo.fr</a>.
                </p>
            </Section>
        </LegalShell>
    );
}
